import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e0125f5a")

_pushScopeId("data-v-e0125f5a")
const _hoisted_1 = { class: "visit-record1" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("i", { class: "el-icon-document" }),
  /*#__PURE__*/_createTextVNode(" API监控 ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("最近一周")
const _hoisted_5 = {
  id: "trend_chart",
  style: {"width":"100%","height":"300px"}
}
const _hoisted_6 = { class: "SearchPaging" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("清空")
const _hoisted_9 = { class: "Statistics visit-record1" }
const _hoisted_10 = /*#__PURE__*/_createVNode("h5", null, [
  /*#__PURE__*/_createVNode("i", { class: "el-icon-edit-outline" }),
  /*#__PURE__*/_createTextVNode(" 性能文件上传监控 ")
], -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("最近一周")
const _hoisted_13 = {
  id: "trend_chart2",
  style: {"width":"100%","height":"300px"}
}
const _hoisted_14 = { class: "SearchPaging" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("清空")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_card, { style: {"width":"1200px","margin":"0 auto"} }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createVNode(_component_el_divider),
                    _createVNode(_component_el_card, { class: "spacName" }, {
                      default: _withId(() => [
                        _createVNode("div", null, [
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "时间" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: _ctx.Timevalue,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.Timevalue = $event)),
                                    type: "daterange",
                                    "start-placeholder": "Start date",
                                    "end-placeholder": "End date",
                                    "default-time": _ctx.defaultTime,
                                    size: "mini",
                                    "value-format": "YYYY-MM-DD"
                                  }, null, 8, ["modelValue", "default-time"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getTime('record_input'))),
                                    size: "mini"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_3
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getTime2('record_input'))),
                                    size: "mini"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_4
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _withDirectives(_createVNode("div", _hoisted_5, null, 512), [
                          [_directive_loading, _ctx.loading]
                        ]),
                        _createVNode("div", _hoisted_6, [
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "每页" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.record,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.record = $event)),
                                    size: "mini",
                                    style: {"width":"50px"},
                                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showList('record_input')))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "条记录" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.record_input,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.record_input = $event)),
                                    placeholder: "搜索",
                                    "prefix-icon": "el-icon-search",
                                    size: "mini"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.recordSearch('record_input')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clearSearch('record_input')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _withDirectives(_createVNode(_component_el_table, {
                          data: _ctx.getMonitorList.results,
                          "header-cell-class-name": "tabelHeader"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              prop: "date",
                              label: "日期",
                              width: "120"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "api",
                              align: "left",
                              label: "API",
                              "min-width": "220",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "time_max",
                              align: "center",
                              label: "最大耗时(ms)"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "time_avg",
                              label: "平均耗时(ms)",
                              width: "150",
                              sortable: "",
                              align: "center"
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              prop: "time_min",
                              label: "最小耗时(ms)"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "count",
                              width: "150",
                              label: "调用次数",
                              sortable: "",
                              align: "center"
                            })
                          ]),
                          _: 1
                        }, 8, ["data"]), [
                          [_directive_loading, _ctx.loading]
                        ]),
                        _createVNode(_component_el_pagination, {
                          currentPage: _ctx.currentPage1,
                          "onUpdate:currentPage": _cache[9] || (_cache[9] = ($event: any) => (_ctx.currentPage1 = $event)),
                          "page-size": _ctx.record,
                          layout: "total, prev, pager, next,jumper",
                          total: _ctx.getMonitorList.count,
                          onCurrentChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleCurrentChange('record_input')))
                        }, null, 8, ["currentPage", "page-size", "total"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_el_divider),
                    _createVNode(_component_el_card, { class: "spacName" }, {
                      default: _withId(() => [
                        _createVNode("div", null, [
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "时间" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: _ctx.Timevalue2,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.Timevalue2 = $event)),
                                    type: "daterange",
                                    "start-placeholder": "Start date",
                                    "end-placeholder": "End date",
                                    "default-time": _ctx.defaultTime,
                                    size: "mini",
                                    "value-format": "YYYY-MM-DD"
                                  }, null, 8, ["modelValue", "default-time"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getTime('statistics_input'))),
                                    size: "mini"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_11
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.getTime2('statistics_input'))),
                                    size: "mini"
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_12
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _withDirectives(_createVNode("div", _hoisted_13, null, 512), [
                          [_directive_loading, _ctx.loading1]
                        ]),
                        _createVNode("div", _hoisted_14, [
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, { label: "每页" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.statistics,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.statistics = $event)),
                                    size: "mini",
                                    style: {"width":"50px"},
                                    onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showList('statistics_input')))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "条记录" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form, { inline: true }, {
                            default: _withId(() => [
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.statistics_input,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.statistics_input = $event)),
                                    placeholder: "搜索",
                                    "prefix-icon": "el-icon-search",
                                    size: "mini"
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini",
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.recordSearch('statistics_input')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_15
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, null, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    size: "mini",
                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.clearSearch('statistics_input')))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_16
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _withDirectives(_createVNode(_component_el_table, {
                          data: _ctx.getMonitorUploadList.results,
                          "header-cell-class-name": "tabelHeader"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              prop: "date",
                              label: "日期",
                              width: "120"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "project.project_name",
                              label: "项目",
                              width: "170",
                              align: "center",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "filename",
                              label: "文件名",
                              "min-width": "200",
                              sortable: "",
                              "show-overflow-tooltip": true,
                              align: "left"
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              prop: "upload_time",
                              label: "解析耗时(s)  "
                            }),
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              prop: "file_size",
                              label: "文件大小(KB)"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "time",
                              width: "180",
                              label: "上传时间",
                              sortable: "",
                              align: "center"
                            }, {
                              default: _withId((scope) => [
                                _createTextVNode(_toDisplayString(scope.row?.time), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"]), [
                          [_directive_loading, _ctx.loading1]
                        ]),
                        _createVNode(_component_el_pagination, {
                          currentPage: _ctx.currentPage2,
                          "onUpdate:currentPage": _cache[19] || (_cache[19] = ($event: any) => (_ctx.currentPage2 = $event)),
                          "page-size": _ctx.statistics,
                          layout: "total, prev, pager, next,jumper",
                          total: _ctx.getMonitorUploadList.count,
                          onCurrentChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleCurrentChange('statistics_input')))
                        }, null, 8, ["currentPage", "page-size", "total"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})